import * as React from "react";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {Field} from "../form/Field";
import {Select} from "../form/fields/Select";
import {api} from "../../api";
import {IWindow} from "../../index";
import {BarChart} from "../charts/BarChart";
import {DoughnutChat} from "../charts/DoughnutChat";

const IWindow: IWindow = (window as IWindow);

export class DashboardFormData {
    @observable election_id = null;
    @observable position_id = null;
    @observable party_id = IWindow.initialState.user.party_id;
}

export class DashboardForm extends CrudForm {
    modelName = 'Dashboard';
    showSubmitButton = false;
    @observable party_candidates: [];
    @observable candidate_by_position: any = [];
    @observable other_party_candidates: any = [];
	@observable is_admin = IWindow.initialState.user.user_type;
    @observable electionSubscription = {
        registeredVoters : 0,
        rejectedVotersData : 0,
        accreditedVoters : 0,
        accreditedVotersData : 0,
        total_votesData : 0,
        UnaccreditedVotersData : 0,
        rejectedDispVotersData : 0,
        rejectedVoters   : 0,
        disputedVoters   : 0,
        PVCCollectedVotersPerc   : 0,
        PVCregisteredVotersTotal   : 0,
        PVCNotregisteredVotersTotal   : 0,
        disputedVotersData   : 0,
		inecVoters : 0,
		pollingunitCount : 0,
		registeredVotersTotal : 0,
        election_polling_unit : 0,
        election_polling_unit_subscriptions : 0,
        inecRegVoters : 0,
        election_unsubscribed_polling_unit : 0,
        federal_constituencies: 0,
        local_government_areas: 0,
        senatorial_districts: 0,
        senatorialDistrict: 0,
        federalConstituencies: 0,
        stateConstituencies: 0,
        state_constituencies: 0,
        states: 0,
        wards: 0,
		total_votes: 0,
		grandTotal:0,
        incidence_count: 0,
        election_candidates_votes: [],
        election_positions: [],
        check_list_count: [],
       
    };
    @observable check_lists: any = [];

    loadMoreData(props: any, module: any) {
        this.onLoadCheckLists();
    }

    onLoadCheckLists = () => {
        api.partyCheckList.getListActionReport({ 
            filters: {
                type: 'polling_unit',
                is_excluded: 0,
                election_id:  this.formStore.getValue('election_id')
            }
        }).then((data: any) => {
            this.check_lists = data;
        });
    };

    onChangeElection = () => { 
        this.formStore.getValue('election_id') &&
          api.dashboard.getElectionPollingUnitSubscriptionAction({
            election_id: this.formStore.getValue('election_id'),
			party_id:  this.formStore.getValue('party_id'),
        }).then((data: any) => {
             this.electionSubscription = data;
            this.party_candidates = data.election_candidates_votes.filter((candidate: any) => {
                return candidate.party_id == (IWindow.initialState.user.party_id ? IWindow.initialState.user.party_id : this.formStore.getValue('party_id') );
            });

            this.other_party_candidates = data.election_candidates_votes.filter((candidate: any) => {
                return candidate.party_id !== (IWindow.initialState.user.party_id ? IWindow.initialState.user.party_id : this.formStore.getValue('party_id') );
            });

            if (data.election_positions && data.election_positions.length) {
                this.formStore.setValue('position_id', data.election_positions[0].value);
                this.candidate_by_position = data.election_candidates_votes.filter((candidate: any) => {
                  
                    return candidate.position_id === data.election_positions[0].value;
                }).map((candidate: any) => {
                    return {
                        label: candidate.name,
                        value: candidate.votes
                    };
                });
            }
        });
    };

    getCandidateRow = (candidate: any) => {
        return <tr key={'candidate-row' + candidate.id}>
            <td>
                <div className="comp-candidate">{candidate.name}
                </div>
                <div className="comp-party">
                    {candidate.party_name}
                </div>
            </td>
            <td className="text-center">
                <div className="icon-candidates text-success my-1"></div>
                <div className="comp-position">
                    <div className="text-center">
                        <small>{candidate.position_name}</small>
                    </div>
                    <div className="text-center">
                        <small>{candidate.region_name}</small>
                    </div>
                </div>
            </td>
            <td className="text-right">
                <div className="comp-votes">
                    <span>{candidate.votes}</span> votes
                </div>
            </td>
        </tr>
    };

    onChangePosition = (position: any) => {
        this.candidate_by_position = this.electionSubscription.election_candidates_votes.filter((candidate: any) => {
            return candidate.position_id === position;
        }).map((candidate: any) => {
            return {
                label: candidate.name,
                value: candidate.votes
            };
        });
    };

    onLoadElections = () => {
        return api.election.getListAction({
            filters: {
                party_id: this.formStore.getValue('party_id'),
            }
        }).then((data: any) => {
            if (data && data.length) {
                this.formStore.setValue('election_id', data[0].id);
                this.onChangeElection();
            }
            return data;
        });
    };

    renderFields() {
        return (

            <>
			 
			
                <div className="row">
                    <div className="ml-auto col-md-3" >
                        <Field
                            key="dashboard-election"
                            name="election_id"
                            placeholder="Select Election..."
                            component={Select}
                            loadOptions={this.onLoadElections}
                            store={this.formStore}
                            required={true}
                            onChange={this.onChangeElection}
                        />
						
						{ this.is_admin == "superuser" ?
					 
						 <Field
                            key={'form_party_id_' + this.formStore.getValue('election_id')}
                            name="party_id"
                            placeholder="Select Party..."
                            component={Select}
                            // loadOptions={this.onLoadElections}
							loadOptions={() => {
                            return api.party.getListAction({
                                filters: {
                                    election_id: this.formStore.getValue('election_id') /* ,
                                    include_competitor_party: 0 */
                                }
                            }).then((data: any) => {
								if (data && data.length) {
									this.formStore.setValue('party_id', data[0].id);
									this.onChangeElection();
								}
							
                                return data.data;
                            });
                        }}
                            store={this.formStore}
                            required={true}
                            onChange={this.onChangeElection}
                        />
						: ''
						}
                    </div>
					 
                </div>

                <div className="row">

                    <div className="col-xl-6 d-flex flex-column"
                         key={'subscription-polling-unit' + this.formStore.getValue('election_id')}>
                        <div className="card dashboard-card box-shadow border-0 rounded-0 flex-grow-1">
                            <div className="card-header d-flex align-items-center">
                                <span className="icon-structure mr-2"></span>
                                <h6>Election Subscription</h6> 
                            </div>
                            <div className="card-body py-0 d-flex flex-column">
                                <div className="row no-gutters flex-grow-1">
                                    <div
                                        className="col-sm-4 dash-sep-sm-right py-4 d-sm-flex flex-sm-column justify-content-sm-center">
                                        <div className="text-center">
                                            <div className="stat-label">Polling units<br/>subscribed</div>
                                            <div
                                                className="stat-value">{this.electionSubscription.election_polling_unit_subscriptions}</div>
                                        </div>
                                        <div className="text-center mt-4">
                                            <div className="stat-label">Polling units<br/>not subscribed</div>
                                            <div
                                                className="stat-value">{this.electionSubscription.election_unsubscribed_polling_unit}</div>
                                        </div>
										
										<div className="text-center mt-4">
                                            <div className="stat-label">INEC REG. VOTERS</div>
                                            <div
                                                className="stat-value">{this.electionSubscription.inecRegVoters}</div>
                                        </div>
										
                                    </div>
                                    <div className="col-sm-8 ">
                                        {
                                            this.formStore.getValue('election_id') ?
                                                <DoughnutChat
                                                    id="polling-unit-chart"
                                                    key={'polling-unit-subcripbtion-chart'}
                                                    title="Polling Units"
                                                    backgroundColor={[
                                                        'rgb(197,44,3)',
                                                        'rgb(41,138,61)',
                                                    ]}
                                                    backgroundHoverColor={[
                                                        'rgba(197,44,3, 0.8)',
                                                        'rgba(41,138,61, 0.78)',
                                                    ]}
                                                    legend={{
                                                        display: true
                                                    }}
                                                    data={[
                                                        {
                                                            label: 'Unsubscribed',
                                                            value: this.electionSubscription.election_unsubscribed_polling_unit,
                                                        },
                                                        {
                                                            label: 'Subscribed',
                                                            value: this.electionSubscription.election_polling_unit_subscriptions,
                                                        }
                                                    ]}
                                                /> : ''
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-6 mt-4 mt-xl-0 d-flex flex-column"
                         key={'subscription-candidates' + this.formStore.getValue('election_id')}>
                        <div className="card dashboard-card box-shadow border-0 rounded-0 flex-grow-1">
                            <div className="card-header d-flex align-items-center">
                                <span className="icon-candidates mr-2"></span>
                                <h6>Candidates </h6>
                                { 
                                    this.formStore.getValue('election_id') &&
                                    this.electionSubscription.election_positions &&
                                    this.electionSubscription.election_positions.length ?
                                        <div className="ml-auto col-md-5">
                                            <Field
                                                key="dashboard-position"
                                                name="position_id"
                                                placeholder="Select Postions..."
                                                component={Select}
                                                store={this.formStore}
                                                options={this.electionSubscription.election_positions}
                                                required={true}
                                                onChange={this.onChangePosition}
                                            />
                                        </div>
                                        : ''
                                }
                            </div>
                            <div className="card-body">
                                {
                                    this.formStore.getValue('position_id') &&
                                    this.candidate_by_position &&
                                    this.candidate_by_position.length ?
                                        <BarChart
                                            id="candidates-chart"
                                            key={'candidate-bar-chart'}
                                            title="Candidates Chart"
                                            data={this.candidate_by_position}/>
                                        : ''
                                }

                            </div>
                        </div>
                    </div>

                </div>

                <div className="row py-2" key={'subscription-region' + this.formStore.getValue('election_id')}>
                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">States</div>
                            <div className="stat-value">{this.electionSubscription.states}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Senatorial Districts</div>
                            <div className="stat-value">{this.electionSubscription.senatorialDistrict}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Local Government Areas</div>
                            <div className="stat-value">{this.electionSubscription.local_government_areas}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Wards</div>
                            <div className="stat-value">{this.electionSubscription.wards}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Polling Units</div>
                            <div
                                className="stat-value">{this.electionSubscription.election_polling_unit_subscriptions}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Federal Constituencies</div>
                            <div className="stat-value">{this.electionSubscription.federalConstituencies}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">State Constituencies</div>
                            <div className="stat-value">{this.electionSubscription.stateConstituencies}</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Incidences</div>
                            <div className="stat-value text-danger">
                                {this.electionSubscription.incidence_count && this.formStore.getValue('election_id') ?
                                    <a href={"/party/" + this.formStore.getValue('election_id') + '/incidence'}
                                       className="text-danger" target="_blank">
                                        {this.electionSubscription.incidence_count} </a>
                                    : this.electionSubscription.incidence_count}
                            </div>
                        </div>
                    </div>

                </div>

                <div className="mt-3">

                    <div className="d-flex flex-column">
                        <div className="card dashboard-card box-shadow border-0 rounded-0 flex-grow-1">
                            <div className="card-header d-flex align-items-center">
                                <span className="icon-bar-chart mr-2"></span>
                                <h6>Election Results</h6>
                            </div>
                            <div className="card-body py-0 d-flex flex-column">
                                <div className="row">
                                    <div className="col-xl-6 dash-sep-xl-right">
                                        <h6 className="light-subheading text-center text-uppercase my-3">My Party</h6>

                                        <div className="competitor-list table-responsive"
                                             key={"my-party" + this.formStore.getValue('election_id')}>
                                            <table className="table table-hover border-top">
                                                <tbody>
                                                {
                                                    this.formStore.getValue('election_id') && this.party_candidates &&
                                                    this.party_candidates.length ?
                                                        this.party_candidates.map((candidate: any) => {
                                                            return (
                                                                this.getCandidateRow(candidate)
                                                            );
                                                        }, this)
                                                        : <tr>
                                                            <td col-span={3}>
                                                                <div className="comp-candidate">No Candidates</div>
                                                            </td>
                                                        </tr>
                                                }

                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                    <div className="col-xl-6">
                                        <h6 className="light-subheading text-center text-uppercase my-3">Competitor
                                            Parties</h6>
                                        <div className="competitor-list table-responsive"
                                             key={"other-party" + this.formStore.getValue('election_id')}  style={{height: '340px' }}>
                                            <table className="table table-hover border-top">
                                                <tbody>
                                                {
                                                    this.formStore.getValue('election_id') && this.other_party_candidates &&
                                                    this.other_party_candidates.length ?
                                                        this.other_party_candidates.map((candidate: any) => {
                                                            return (
                                                                this.getCandidateRow(candidate)
                                                            );
                                                        }, this)
                                                        : <tr>
                                                            <td col-span={3}>
                                                                <div className="comp-candidate">No Candidates</div>
                                                            </td>
                                                        </tr>
                                                }

                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>





<div className="mt-3">

                    <div className="d-flex flex-column">
                        <div className="card dashboard-card box-shadow border-0 rounded-0 flex-grow-1">
                            <div className="card-header d-flex align-items-center">
                                <span className="icon-bar-chart mr-2"></span>
                        <h6>NUMBER OF POLLING UNITS THAT HAVE REPORTED THE FOLLOWING DATA : { this.electionSubscription.pollingunitCount}</h6>
                            </div>
                            <div className="card-body py-0 d-flex flex-column">
							


                                <div className="row pt-2">
								
									
									
									
									<div className="col-sm-3 dashstattitle "  key={'registeredVoters'}>
                                        <h4 className="text-center py-3 mt-2">INEC Voters  <br/> { "(" + ((this.electionSubscription.inecVoters > 0 ? this.electionSubscription.inecVoters : 0) + ")") }</h4>
                                                <DoughnutChat
                                                    id="polling-unit-chart"
                                                     key={'registeredVoters'}
                                                    title=""
                                                    backgroundColor={[
                                                        'rgb(235,235,235)',
                                                        'rgb(41,138,61)',
                                                    ]}
                                                    backgroundHoverColor={[
                                                        'rgb(235,235,235)',
                                                        'rgba(41,138,61, 0.78)',
                                                    ]}
                                                    legend={{
                                                        display: false
                                                    }}
                                                    data={[
                                                        {
                                                            label: '',
                                                            value: (this.electionSubscription.inecVoters > 0 ? '' : 0),
                                                        },
                                                        {
                                                            label: 'INEC Voters',
                                                            value: (this.electionSubscription.inecVoters > 0 ? this.electionSubscription.inecVoters : 0),
                                                        }
                                                    ]}
                                                />  
                                        

                                    </div>
									
									
									
									
									
									<div className="col-sm-3 dashstattitle " key={'registeredVoters'}>
                                        
										<h4 className="text-center py-3 mt-2">PVC Collected  <br/> { "(" + (this.electionSubscription.PVCregisteredVotersTotal > 0 ? this.electionSubscription.PVCregisteredVotersTotal : 0 ) + "," + this.electionSubscription.PVCCollectedVotersPerc + "%)" }</h4>
										
                                                <DoughnutChat
                                                    id="polling-unit-chart"
                                                     key={'registeredVoters-chart'}
                                                    title=""
                                                    backgroundColor={[
                                                        'rgb(235,235,235)',
                                                        'rgb(41,138,61)',
                                                    ]}
                                                    backgroundHoverColor={[
                                                        'rgb(235,235,235)',
                                                        'rgba(41,138,61, 0.78)',
                                                    ]}
                                                    legend={{
                                                        display: false
                                                    }}
                                                    data={[
                                                        {
                                                            label: 'INEC Voters (%) ' +  ( this.electionSubscription.inecVoters > 0 ? this.electionSubscription.inecVoters : 0),
                                                            value:  ( (this.electionSubscription.inecVoters > 0 || this.electionSubscription.inecVoters > 0) ?  (100 - this.electionSubscription.PVCCollectedVotersPerc) : 0) , //this.electionSubscription.PVCNotregisteredVotersTotal,
                                                        },
                                                        {
                                                            label: 'PVC Collected (%) ' + (this.electionSubscription.PVCregisteredVotersTotal > 0 ? this.electionSubscription.PVCregisteredVotersTotal : 0),
                                                            // value: this.electionSubscription.registeredVoters,
                                                            value: (this.electionSubscription.PVCregisteredVotersTotal > 0 ? this.electionSubscription.PVCCollectedVotersPerc : 0),
                                                        }
                                                    ]}
                                                />  
                                        

                                    </div>
								
								
								
                               
                 
                            




<div className="col-sm-3 dashstattitle " key={'accreditedVoters'}>

<h4 className="text-center py-3 mt-2">Accredited Voters  <br/> { "(" + (this.electionSubscription.accreditedVotersData > 0 ? this.electionSubscription.accreditedVotersData:0 ) + "," + this.electionSubscription.accreditedVoters + "%)" }</h4>
                                        
                                                <DoughnutChat
                                                    id="polling-unit-chart"
                                                    key={'accreditedVoters'}
                                                    title=""
                                                    backgroundColor={[
                                                        'rgb(235,235,235)',
                                                        'rgb(41,138,61)',
                                                    ]}
                                                    backgroundHoverColor={[
                                                        'rgb(235,235,235)',
                                                        'rgba(41,138,61, 0.78)',
                                                    ]}
                                                    legend={{
                                                        display: false
                                                    }}
                                                    data={[
                                                        {
                                                            label: 'Unaccredited PVC Collected (%) ' + (this.electionSubscription.PVCregisteredVotersTotal - this.electionSubscription.accreditedVotersData),
                                                            value:  ( (this.electionSubscription.PVCregisteredVotersTotal > 0 ||  this.electionSubscription.accreditedVotersData > 0 ) ? (100 - this.electionSubscription.accreditedVoters) : 0 ) , //this.electionSubscription.UnaccreditedVotersData,
                                                        },
                                                        {
                                                            label: 'Accredited Voters (%) ' + this.electionSubscription.accreditedVotersData,
                                                            value: ((this.electionSubscription.accreditedVotersData > 0 || this.electionSubscription.accreditedVoters > 0  )  ? this.electionSubscription.accreditedVoters  :0 ) ,
                                                        }
                                                    ]}
                                                />  
                                        

                                    </div>


                                   									
									

<div className="col-sm-3 dashstattitle " key={'rejectedVoters'}>
                                        
										<h4 className="text-center py-3 mt-2">Valid Votes  <br/> { "(" + (Number(this.electionSubscription.grandTotal) - (Number(this.electionSubscription.rejectedDispVotersData)) ) + "," + ((Number(this.electionSubscription.grandTotal) - (Number(this.electionSubscription.rejectedDispVotersData)) ) > 0 ?  (((Number(this.electionSubscription.grandTotal) - (Number(this.electionSubscription.rejectedDispVotersData)) )  / Number(this.electionSubscription.grandTotal) ) * 100   ) : 0 ).toFixed(2)  + "%)" }</h4>
										
                                                <DoughnutChat
                                                    id="polling-unit-chart"
                                                    key={'rejectedVoters'}
                                                    title=""
                                                    backgroundColor={[
                                                        // 'rgb(235,235,235)',
														'rgb(207, 87, 83)',
                                                        'rgb(41,138,61)',
                                                    ]}
                                                    backgroundHoverColor={[
                                                        // 'rgb(235,235,235)',
														'rgb(207, 87, 83)',
                                                        'rgba(41,138,61, 0.78)',
                                                    ]}
                                                    legend={{
                                                        display: false
                                                    }}
                                                    data={[
                                                        {
                                                            label: 'Invalid Votes (%) ' + this.electionSubscription.rejectedDispVotersData,
                                                            value: (this.electionSubscription.rejectedDispVotersData > 0 ?  ((Number(this.electionSubscription.rejectedDispVotersData)  / Number(this.electionSubscription.grandTotal) ) * 100   ) : 0 ).toFixed(2) ,
															// this.electionSubscription.total_votesData,
                                                        },
                                                        {
															label: 'Valid Votes (%) ' + (Number(this.electionSubscription.grandTotal) - (Number(this.electionSubscription.rejectedDispVotersData)) ) + ' ',
                                                            value:  ((Number(this.electionSubscription.grandTotal) - (Number(this.electionSubscription.rejectedDispVotersData)) ) > 0 ?  (((Number(this.electionSubscription.grandTotal) - (Number(this.electionSubscription.rejectedDispVotersData)) )  / Number(this.electionSubscription.grandTotal) ) * 100   ) : 0 ).toFixed(2)   , 
                                                            
                                                        }
                                                    ]}
                                                />  
                                        

                                    </div>
							
							
                                   
									
									



{/*
<div className="col-sm-4 dashstattitle " key={'disputedVoters'}>
                                        
                                                <DoughnutChat
                                                    id="polling-unit-chart"
                                                    key={'disputedVoters'}
                                                    title={"Disputed Votes (" + this.electionSubscription.disputedVotersData + "," + this.electionSubscription.disputedVoters+ "%)"}
                                                    backgroundColor={[
                                                        'rgb(235,235,235)',
                                                        'rgb(41,138,61)',
                                                    ]}
                                                    backgroundHoverColor={[
                                                        'rgb(235,235,235)',
                                                        'rgba(41,138,61, 0.78)',
                                                    ]}
                                                    legend={{
                                                        display: true
                                                    }}
                                                    data={[
                                                        {
                                                            label: 'Total Votes',
                                                            value: this.electionSubscription.total_votes,
                                                        },
                                                        {
                                                            label: 'Disputed Votes',
                                                            value: this.electionSubscription.disputedVoters,
                                                        }
                                                    ]}
                                                />  
                                        

                                    </div>

						*/ }			
								

								
									
									
									


                               
                </div>
</div>
</div>
</div>
</div>

                <div className="row pt-2">&nbsp;</div>







                            </div>
                        </div>
                    </div>

                </div>

                <div className="row pt-2">
                    {
                        this.formStore.getValue('election_id') && this.check_lists &&
                        this.check_lists.length ?
                            this.check_lists.map((check_list: any, i: number) => {
                                let checkList: any = this.electionSubscription.check_list_count ?
                                    this.electionSubscription.check_list_count.find((object: any) => {
                                        return object.check_list_id == check_list.id;
                                    }) : null;
                                let checkListCount = 0;
                                if (checkList && typeof  checkList != "undefined") {
                                    checkListCount = Number(checkList.total_count);
                                }

                                // console.log(this.electionSubscription.registeredVoters);
                                // console.log(this.electionSubscription.accreditedVoters);
                                // console.log(this.electionSubscription.rejectedVoters);
                                 // console.log('dhaval - ' + this.electionSubscription.check_list_count);
                                 // console.log('dhaval - ' + this.is_admin);
                                 
                                //  let totalCount = 0;
                                  
                              /*  if(check_list.id == 3)
                                  {
                                    totalCount = this.electionSubscription.registeredVoters;
                                  }
                                else if(check_list.id == 5)
                                  {
                                    totalCount = this.electionSubscription.accreditedVoters; 
                                  }
                                else if(check_list.id == 12)
                                  {
                                    totalCount = this.electionSubscription.rejectedVoters;
                                  }
                                else if(check_list.id == 13)
                                  {
                                    totalCount = this.electionSubscription.disputedVoters;
                                  } 
                                else if(check_list.id == 15)
                                  {
                                    totalCount = 0;
                                  } 
                                else if(check_list.id == 19)
                                  {
                                    totalCount = 0;
                                  }   */

   
                                return (

                                    <div className="col-md-4 d-flex flex-column mt-3"
                                         key={'check-list' + check_list.id + this.formStore.getValue('election_id')}>
                                        <div className="step-card box-shadow border-0 rounded-0">
                                            <div className="step-info">
                                                <h6 className="step-title">{check_list.title}</h6>
                                                <div className="step-desc">{check_list.description}<small style={{fontWeight: 'bold' }}>Total: {checkListCount}</small></div>
                                            </div>
                                            <div className="step-chart-wrap" style={{width: '150px'}}
                                                 data-id={'check-list-chart' + check_list.id + '-' + checkListCount}>
                                                <DoughnutChat
                                                    key={'check-list-chart' + check_list.id + '-' + checkListCount}
                                                    legendDisplay={false}
                                                    backgroundColor={[
                                                        'rgb(235,235,235)',
                                                        'rgb(41,138,61)',
                                                    ]}
                                                    backgroundHoverColor={[
                                                        'rgb(235,235,235)',
                                                        'rgba(41,138,61, 0.78)',
                                                    ]}
                                                    legend={{
                                                        display: false
                                                    }}
                                                    data={[
                                                        {
                                                            label: '',
                                                            value: this.electionSubscription.election_polling_unit_subscriptions,
                                                        },
                                                        {
                                                            label: '',
                                                            value: check_list.checkListCounts,    
                                                        }
                                                    ]}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                            : ''
                    }
                </div>







               









            </>
        );
    }
}

export class DashboardPage extends React.Component {
    modelName = 'Dashboard';

    render() {
        return (
            <>
                <DashboardForm
                />
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/DashboardPage.tsx